import PropTypes from 'prop-types';
import CaseStudiesCommon from 'components/CaseStudiesCommon';
import MetaTags from 'components/Common/MetaTags';
import AiEngineeringPodBadge from 'UI/components/AiEngineeringPodBadge';
import { rootUrl } from 'utils/helper';
import { PAGES, PAGES_WITH_DARK_BREADCRUMBS } from 'utils/constants';
import { routes } from 'utils/routes';
import { useFetchPageQuery } from 'redux/apis/page';
import { getBreadcrumbs } from 'utils/breadcrumbs';
import cn from 'classnames';
import { useRouter } from 'next/router';
import styles from './styles.module.scss';
import CaseStudiesFooter from '../../UI/sections/CaseStudiesFooter';

const CaseStudiesContainer = ({ introSection, slug }) => {
  const { data = {}, isLoading } = useFetchPageQuery(slug);
  const { asPath } = useRouter();

  if (isLoading) {
    return null;
  }

  const {
    contentModules,
    pageTitle,
    metaData: {
      metaTitle,
      metaDescription,
      ogImage,
      metaRobots,
    },
  } = data;

  const projectMetadata = {
    metaTitle: metaTitle || `${pageTitle} | Yellow`,
    metaDescription: metaDescription || (pageTitle && `Yellow professionals have created ${pageTitle}. Read our case study to find more!`),
    url: `${rootUrl}${routes.portfolio.getRoute(slug).path}`,
    metaRobots,
    ogImage,
  };

  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! DONT FORGET TO USE IT DURING RESOLVING MERGE CONFLICT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  const breadcrumbs = getBreadcrumbs(PAGES.project, {
    slug,
    title: pageTitle,
  });
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! DONT FORGET TO USE IT DURING RESOLVING MERGE CONFLICT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  const breadcrumbsTheme = PAGES_WITH_DARK_BREADCRUMBS.includes(slug) ? 'dark' : null;

  return (
    <>
      <MetaTags
        page={PAGES.portfolio}
        pageMetadata={projectMetadata}
        breadcrumbs={breadcrumbs} // !!! AND HERE !!!
      />
      <main className={cn(styles.main, styles[slug])}>
        {contentModules?.map((contentModule) => {
          const { fields, sys } = contentModule;

          return (
            <CaseStudiesCommon
              key={sys.id}
              type={slug}
              introSection={introSection}
              section={contentModule}
              data={fields}
              breadcrumbs={breadcrumbs}
              breadcrumbsTheme={breadcrumbsTheme}
            />
          );
        })}
        <CaseStudiesFooter
          type={slug}
          pathname={asPath}
        />
        <AiEngineeringPodBadge />
      </main>
    </>
  );
};

CaseStudiesContainer.propTypes = {
  introSection: PropTypes.instanceOf(Object).isRequired,
};

export default CaseStudiesContainer;
